import React, { useEffect, useState } from "react";
import { IoIosCloudOutline } from "react-icons/io";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate, useParams } from "react-router-dom";
import TableCloud from "../TableEngine/TableCloud";
import FormatDateTime from "../../Functions/FormatDate";
import { FiTrash } from "react-icons/fi";
import { IoCloudUploadOutline } from "react-icons/io5";
import UploadFileModal from "./UploadFileModal";
import LoadingCloudStorage from "./LoadingCloudStorage";
import ErrorPage from "../../Components/ErrorPage";
import ActionFileModal from "./ActionFileModal";
import ShareFileModal from "./ShareFileModal";
import FilePreview from "./FilePreview";
import { BsFolderPlus } from "react-icons/bs";
import NewFolderModal from "./NewFolderModal";

const CloudMain = ({ userData, no_session }) => {
    const { t } = useLanguage()
    const { project_id } = useParams()

    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id");
    const [sizeCloud, setSizeCloud] = useState("")

    const [animateReset, setAnimateReset] = useState(false)
    const [searchQuery, setSearchQuery] = useState("");

    const [files, setFiles] = useState([]);
    const [filteredFiles, setFilteredFiles] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [newFolderModal, setNewFolderModal] = useState(false)
    const [showShareModal, setShowShareModal] = useState(false)
    const [selectedFileID, setSelectedFileID] = useState("")
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [projectName, setProjectName] = useState(null)
    const [path, setPath] = useState(null)
    const [action, setAction] = useState(null)
    const [openPreview, setOpenPreview] = useState(false)
    const [fileUrl, setFileUrl] = useState(null)
    const [filename, setFileName] = useState(null)

    const HandleNavigate = (path) => {
        navigate(`/project_panel/${project_id}/cloud_storage/${path}`)
    }

    useEffect(() => {
        if (user_id) {
            fetchCloud();
        }

        if (userData) {
            setSizeCloud(userData.total_storage_kb)
            setProjectName(userData.projects.project_name)
            setPath(userData.projects.project_name)
        }
    }, [user_id, userData]);


    const resetFilters = () => {
        setSearchQuery("")
        setFilteredFiles(files);
        setAnimateReset(true)
        setTimeout(() => {
            setAnimateReset(false)
        }, 1000);
    };

    const handleOpenUploadModal = () => {
        setShowUploadModal(true);
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
    }


    const fetchCloud = async () => {
        setLoading(true)
        setFiles([])
        setFilteredFiles([])
        try {
            const response = await fetch("https://backend.erioon.com/get_private_cloud", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, project_id }),
            });
            if (response.ok) {
                const result = await response.json();
                const files = result.files || {};
                const recordsArray = Object.values(files)
                if (Array.isArray(recordsArray)) {
                    setFiles(recordsArray);
                    setFilteredFiles(recordsArray);
                } else {
                    throw new Error("Invalid response format");
                }
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Failed to load files.");
            }
            setLoading(false);
        } catch (err) {
            setLoading(false)
            setError("Failed to connect to the server. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const handleActionClick = (fileId, actionModal) => {
        setSelectedFiles((prevFiles) => [...new Set([...prevFiles, ...[].concat(fileId)])]);
        setShowDeleteModal(true);
        setAction(actionModal);
    };



    const handleCloseActionModal = () => {
        setShowDeleteModal(false);
        setAction(null);
    };


    const tableData = filteredFiles.map((file) => {
        const sizeInKB = file.size_kb || 0;
        const formattedSize =
            sizeInKB >= 1000
                ? `${(sizeInKB / 1024).toFixed(2)} MB`
                : `${sizeInKB.toFixed(2)} KB`;

        return {
            name: {
                label: t.cloud.cloud_table.filename,
                value: file.filename || "N/A",
                type: "name"
            },
            timestamp: {
                label: t.cloud.cloud_table.created,
                value: FormatDateTime(file.timestamp) || "N/A",
                type: "timestamp"
            },
            _id: {
                label: t.cloud.cloud_table.id,
                value: file._id || "N/A",
                type: "_id"
            },
            size: {
                label: t.cloud.cloud_table.size,
                value: formattedSize,
                type: "size"
            },
            folder_path: {
                label: t.cloud.cloud_table.folder_path,
                value: file.folder_path || "N/A",
                type: "folder_path"
            },
            file: {
                label: t.cloud.cloud_table.preview,
                value: file.file_url || "N/A",
                type: "file"
            },
            status: {
                label: t.cloud.cloud_table.status,
                value: file.status || "N/A",
                type: "status"
            },
        };
    });

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredFiles(files);
            return;
        }

        const filtered = files.filter((file) => {
            return (
                file._id.toLowerCase().includes(query) ||
                file.filename.toLowerCase().includes(query) ||
                file.status.toLowerCase().includes(query) ||
                file.timestamp.toLowerCase().includes(query) ||
                file.file_url.toLowerCase().includes(query)
            );
        });

        setFilteredFiles(filtered);
    };


    const handleCheckboxChange = (fileId, isChecked) => {
        setSelectedFiles((prevSelected) =>
            isChecked ? [...prevSelected, fileId] : prevSelected.filter((id) => id !== fileId)
        );
    };

    const handleShareSelected = () => {
        if (selectedFiles.length > 0) {
            setShowShareModal(true);
        }
    };

    const handleOpenShareModal = (fileId, action) => {
        setShowShareModal(true);
        setSelectedFiles((prevIds) => [...prevIds, fileId])
    };

    const handleCloseShareModal = () => {
        setShowShareModal(false);
    }

    const ShowPreview = (file_url, file_name) => {
        setOpenPreview(true)
        setFileUrl(file_url)
        setFileName(file_name)
    }

    const HandleClosePreview = () => {
        setOpenPreview(false)
        setFileUrl(null)
        setFileName(null)
    }


    if (loading) {
        return <LoadingCloudStorage />;
    }

    if (error) {
        return <ErrorPage />;
    }


    return (
        <div className="main_view_container">
            <p className="new_section_main_view_title">
                <i><IoIosCloudOutline /></i> {t.cloud.title}
            </p>
            <p className="new_section_main_view_subtitle">
                {(sizeCloud / 1024 / 1024 / 1024).toFixed(1)} / 100GB {t.cloud.consumed}
            </p>
            <div className="cloud_main_container">
                <div className="cloud_cont">
                    <div className="cloud_headers_cont">
                        <div className="cloud_headers_cont_item" onClick={handleOpenUploadModal}>
                            <i><IoCloudUploadOutline /></i>
                            {t.cloud.upload_file}
                        </div>

                        <div className="cloud_headers_cont_item" onClick={() => { HandleNavigate("deleted_files") }}>
                            <i><FiTrash /></i>
                            {t.cloud.deleted_files}
                        </div>
                        {/* <div className="cloud_headers_cont_item" onClick={() => setNewFolderModal(true)}>
                            <i><BsFolderPlus /></i>
                            New folder
                        </div> */}
                    </div>
                    <div className="all_items_cont">
                        <p className="all_items_cont_title">{t.cloud.all_files}</p>
                        <div className="filter_container">
                            {selectedFiles && selectedFiles.length > 0 && (
                                <>
                                    <button className="filter_btn" onClick={() => handleActionClick(selectedFiles, "delete_temporarily")}>
                                        <i><FiTrash /></i> {t.cloud.move_to_deleted}
                                    </button>
                                    <button className="filter_btn" onClick={handleShareSelected}>
                                        <i className="fa-solid fa-share"></i> {t.cloud.share}
                                    </button>
                                </>
                            )}
                            <button
                                className={`filter_btn`}
                                onClick={resetFilters}
                            >
                                <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                            </button>
                            <div className="filter_input_cont">
                                <i className="fa-solid fa-magnifying-glass"></i>
                                <input
                                    className="filter_input"
                                    placeholder={t.search}
                                    value={searchQuery}
                                    onChange={handleSearch}
                                />
                            </div>
                        </div>
                        <TableCloud data={tableData} handleActionClick={handleActionClick} handleOpenShareModal={handleOpenShareModal} selectedFiles={selectedFiles}
                            handleCheckboxChange={handleCheckboxChange} ShowPreview={ShowPreview} />
                    </div>
                </div>

                <FilePreview HandleClosePreview={HandleClosePreview} openPreview={openPreview} fileUrl={fileUrl} filename={filename} />
            </div>
            <UploadFileModal
                show={showUploadModal}
                handleClose={handleCloseUploadModal}
                fetchCloud={fetchCloud}
                project_id={project_id}
                folder_path={projectName}
            />

            <ActionFileModal
                project_id={project_id}
                show={showDeleteModal}
                handleClose={handleCloseActionModal}
                selectedFiles={selectedFiles}
                fetchCloud={fetchCloud}
                actionModal={action}
                setSelectedFiles={setSelectedFiles}
            />
            <ShareFileModal
                show={showShareModal}
                handleClose={handleCloseShareModal}
                filesToShare={selectedFiles}
                fileObject={files.find((file) => file._id === selectedFileID)}
            />

            <NewFolderModal
                show={newFolderModal}
                handleClose={() => setNewFolderModal(false)}
                fetchCloud={fetchCloud}
                project_id={project_id}
                folder_path={projectName}
            />
        </div>
    )
}

export default CloudMain